import { render, staticRenderFns } from "./MaintainerIssues.vue?vue&type=template&id=dd4e3b2a&scoped=true&"
import script from "./MaintainerIssues.vue?vue&type=script&lang=js&"
export * from "./MaintainerIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4e3b2a",
  null
  
)

export default component.exports